/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Save_ProjectInputs */



/**
* | output |
* | --- |
* | "Save project or open 'Save As' dialogue box" |
*
* @param {Shortcut_Keys_Desc_Save_ProjectInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_save_project = /** @type {((inputs?: Shortcut_Keys_Desc_Save_ProjectInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Save_ProjectInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrer le projet ou ouvrir la boite de dialogue 'Enregistrer sous'")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projekt speichern oder Dialogfeld „Speichern unter“ öffnen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salva il progetto o apri la finestra di dialogo \"Salva con nome\"")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сохраните проект или откройте диалоговое окно «Сохранить как».")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guardar el proyecto o abrir el cuadro de diálogo \"Guardar como\"")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("保存项目或打开“另存为”对话框")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトを保存するか、「名前を付けて保存」ダイアログボックスを開きます")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट सेव करें या 'सेव एज़' डायलॉग बॉक्स खोलें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Salve o projeto ou abra a caixa de diálogo \"Salvar como\".")
	return /** @type {LocalizedString} */ ("Save project or open 'Save As' dialogue box")
});